'use strict';
import angular from 'angular';
import PagingController from './paging.controller';
export default angular.module('directives.paging', [])
    .component('paging', {
    template: require('./paging.html'),
    bindings: {
        pageModel: '=',
        pageChanged: '&',
        disabled: '='
    },
    controller: PagingController
})
    .name;
//# sourceMappingURL=index.js.map